import { Injectable } from '@angular/core';
import {Customer} from '../dto/customer';
import {CustomersService} from '../home/services/customers.service';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {CustomerOverviewViewContainerDto} from '../dto/customerOverviewViewContainerDto';
import {DataListModel} from '../models/data-list-model';
import {DateTableFilter} from '../table-datasouces/date-table-filter';
import {PrevNextModel} from '../models/prev-next-model';
import {toISODateString} from '../providers/app-date-adapter';
import {PrevNextIdModel} from '../models/prev-next-id-model';
import {CrudService} from './crud/interfaces/crud-service.interface';
import {CustomerOverviewList} from '../dto/customerOverviewList';

@Injectable({
  providedIn: 'root'
})
export class CustomersOverviewService implements CrudService<CustomerOverviewList> {

  readonly apiPathOverview = 'customer-overview/';
  readonly apiPathDelete = 'customers/';

  constructor(private http: HttpClient) {

  }

  getMany(
    pageIndex: number,
    pageSize: number,
    sortField: string,
    sortDirection: string,
    filterString: string,
    dateFilterCols: string[],
    startFilterDate: Date,
    endFilterDate: Date,
    someAdditionalData: string,
    additionalFilterData?: string[],
    enumFilter?: { key: string; value: string },
    companiesFilter?: string[],

    additionalField1?: string,
    additionalField2?: string,
    additionalValue1?: string,
    additionalValue2?: string,
    identStatusFilter?: string[],
    productsFilter?: string[],
    cardStatusFilter?: string[],
    countriesFilter?: string[],
  ) {
    let params = new HttpParams()
      .set('page', pageIndex.toString())
      .set('pageSize', pageSize.toString())
      .set('filterString', filterString)
      .set('sortField', sortField)
      .set('sortDirection', sortDirection)
      .set('someAdditionalData', someAdditionalData);

    if (dateFilterCols instanceof Array) {
      dateFilterCols.forEach(element => {
        params = params.append('dateFilterCols', element);
      });
    }
    if (additionalFilterData instanceof Array) {
      additionalFilterData.forEach(element => {
        params = params.append('additionalFilterData', element);
      });
    }
    if (enumFilter) {
      params = params.append('enumFilter', JSON.stringify(enumFilter));
    }

    if (companiesFilter instanceof Array) {
      companiesFilter.forEach(element => {
        params = params.append('companiesFilter', element);
      });
    }

    if (countriesFilter instanceof Array) {
      countriesFilter.forEach(element => {
        params = params.append('countriesFilter', element);
      });
    }

    if (identStatusFilter instanceof Array) {
      identStatusFilter.forEach(element => {
        params = params.append('identStatusFilter', element);
      });
    }


    return this.http.get(this.apiPathOverview + 'search', { params }) as Observable<DataListModel<CustomerOverviewList>>;
  }


  getPrevNextIds(filters: DateTableFilter, customerId: number): Observable<PrevNextIdModel> {
    const params = this.getFilterParams(filters);
    return this.http.get(`${this.apiPathOverview}${customerId}/prev-next-ids`, { params }) as Observable<PrevNextIdModel>;
  }

  getFilterParams(filters: DateTableFilter): HttpParams {
    const str = filters?.str || '';
    const dateFilterCols = filters?.dateFilterCols || [];
    const startFilterDate = filters?.startFilterDate || null;
    const endFilterDate = filters?.endFilterDate || null;
    const companiesFilter = filters?.companiesFilter || null;
    const identStatusFilter = filters?.identStatusFilter || null;
    const countriesFilter = filters?.countriesFilter || null;
    const page = filters?.page || 1;
    const pageSize = filters?.pageSize || 20;


    let params = new HttpParams()


      .set('filterString', str)
      .set('page', page.toString())
      .set('pageSize', pageSize.toString())
      .set('someAdditionalData', filters?.someAdditionalData)
      .set('startFilterDate', toISODateString(startFilterDate))
      .set('endFilterDate', toISODateString(endFilterDate));
    if (filters?.sortField) {
      params = params.set('sortField', filters.sortField);
    }
    if (filters?.sortDirection) {
      params = params.set('sortDirection', filters.sortDirection);
    }

    if (filters?.enumFilter) {
      params = params.set('enumFilter', filters.enumFilter.value + '_' + filters.enumFilter.key);
    }

    if (countriesFilter instanceof Array) {
      countriesFilter.forEach(element => {
        params = params.append('countriesFilter', element);
      });
    }

    if (companiesFilter instanceof Array) {
      companiesFilter.forEach(element => {
        params = params.append('companiesFilter', element);
      });
    }

    if (identStatusFilter instanceof Array) {
      identStatusFilter.forEach(element => {
        params = params.append('identStatusFilter', element);
      });
    }

    if (dateFilterCols instanceof Array) {
      dateFilterCols.forEach(element => {
        params = params.append('dateFilterCols', element);
      });
    }

    return params;
  }

  getSolr(id: number) {
    return this.http.get(this.apiPathOverview + 'get-solr/' + id) as Observable<Customer>;
  }

  add(item: CustomerOverviewList): Observable<Object> {
    return undefined;
  }

  delete(id: any) {
    return this.deleteMany([id]);
  }
  restore(id: any) {
    return this.restoreMany([id]);
  }

  deleteMany(idList: any[]): Observable<Object> {
    let httpParams = new HttpParams();

    idList.forEach(id => {
      httpParams = httpParams.append('list', id.toString());
    });

    return this.http.delete(this.apiPathDelete, { params: httpParams });
  }
  restoreMany(idList: any[]): Observable<Object> {
    let httpParams = new HttpParams();
    idList.forEach(id => {
      httpParams = httpParams.append('list', id.toString());
    });
    return this.http.patch(this.apiPathDelete, null, { params: httpParams });
  }

  get(id: any): Observable<CustomerOverviewList> {
    return undefined;
  }

  update(id: any, item: CustomerOverviewList): Observable<Object> {
    return undefined;
  }


}
